import { CreateYourOwnData } from './type'

export const createYourOwnData: CreateYourOwnData = {
  eyebrow: 'Made for your child',
  headline: 'Want something totally original? Tell Pixie what to make.',
  body: 'Describe any adventure you can dream up, add your child\'s look, and Pixie writes and illustrates an entirely new book. Every page, every illustration, made just for them.',
  steps: [
    { number: '1', title: 'Describe the Adventure', description: 'Tell Pixie what you want the story to be about' },
    { number: '2', title: 'Add Your Child\'s Look', description: 'So they become the hero of every page' },
    { number: '3', title: 'Choose an Art Style', description: 'Pick from hand-crafted illustration styles' },
    { number: '4', title: 'Pixie Writes & Illustrates', description: 'Your whole book is ready in minutes' },
  ],
  imageUrl: '/images/child-to-story.png',
  imageAlt: 'Child\'s personalised character shown beside their illustrated storybook',
  ctaText: 'Create a Custom Story',
  ctaLink: '/shop',
  supportText: 'Need help? Our team guides you through every step — reach out at support@pixieworldstore.com.',
}
